/* EOK Shop — zentrales Preis-/Coupon-Modul (window.EokPricing)
   Eine Detektion, ein State, ein Event ('eok:coupon:changed'),
   alle HTML-Renderer für Karten, PDP, Upsells und Cart-Drawer.
   Erwartet window.eokCouponConfig + window.eokCouponSeed aus
   snippets/eok-coupon-config.liquid (vor diesem Script gerendert). */

(function () {
  'use strict';

  var CACHE_KEY = 'eok_dc_v1';
  var TAG = '<i class="bi bi-tag-fill"></i>';
  var ARROW = '<i class="bi bi-arrow-right-short"></i>';

  /* ── State ─────────────────────────────────────────────────── */
  function inactiveCoupon() {
    return { active: false, title: '', scope: '', type: '', pct: 0, fixed: 0, collections: null, productIds: null };
  }
  var _coupon = inactiveCoupon();
  var _domReady = document.readyState !== 'loading';

  /* ── localStorage-Cache (nur Fallback für Codes ohne Config-Eintrag) ── */
  function cacheRead(code) {
    try {
      var r = JSON.parse(localStorage.getItem(CACHE_KEY));
      return (r && r.code === code) ? r : null;
    } catch (e) { return null; }
  }
  function cacheWrite(c) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({
        code: c.title, type: c.type, pct: c.pct, fixed: c.fixed, targetAll: c.scope === 'order'
      }));
    } catch (e) {}
  }
  function cacheClear() {
    try { localStorage.removeItem(CACHE_KEY); } catch (e) {}
  }

  /* ── Auflösung: Config gewinnt, unbekannte Codes degradieren wie bisher ── */
  function resolve(title, fb) {
    title = String(title || '').trim();
    if (!title) return inactiveCoupon();
    var cfg = (window.eokCouponConfig || {})[title.toUpperCase()];
    if (cfg) {
      var val = parseFloat(cfg.value) || 0;
      var cfgType = cfg.valueType === 'fixed_amount' ? 'fixed_amount'
        : (cfg.valueType === 'free_shipping' ? 'free_shipping' : 'percentage');
      return {
        active: true,
        title: title,
        scope: cfg.scope === 'order' ? 'order' : 'products',
        type: cfgType,
        pct: cfgType === 'percentage' ? Math.round(val) : 0,
        fixed: cfgType === 'fixed_amount' ? Math.round(val * 100) : 0,
        collections: (cfg.collections && cfg.collections.length) ? cfg.collections.map(String) : null,
        productIds: (cfg.productIds && cfg.productIds.length) ? cfg.productIds.map(Number) : null
      };
    }
    /* Nicht in der Config: Verhalten wie das alte System (gilt für alles,
       Wert aus discount_applications bzw. localStorage-Cache) */
    fb = fb || {};
    var cached = cacheRead(title);
    var type = fb.valueType || (cached && cached.type) || 'percentage';
    /* Gratis-Versand-Codes meldet Shopify als percentage 100 auf shipping_line —
       niemals als Preisrabatt interpretieren */
    if (fb.targetType === 'shipping_line') type = 'free_shipping';
    if (type === 'free_shipping') {
      /* Ohne Config-Eintrag ist unbekannt, welche Produkte qualifizieren → nur Drawer-Chip */
      return {
        active: true, title: title, scope: 'order',
        type: 'free_shipping', pct: 0, fixed: 0, collections: null, productIds: null
      };
    }
    var hasVal = fb.value !== undefined && fb.value !== null && fb.value !== '';
    var val2 = hasVal ? parseFloat(fb.value) : null;
    var pct = 0, fixed = 0, isOrder = false;
    if (type === 'fixed_amount') {
      fixed = val2 !== null ? Math.round(val2 * 100) : (cached ? (cached.fixed || 0) : 0);
      /* Ohne target_selection-Info (discount_codes-Fallback): fixed ⇒ Wertgutschein wie bisher */
      isOrder = fb.targetSelection ? fb.targetSelection === 'all' : !(cached && cached.targetAll === false);
    } else {
      type = 'percentage';
      pct = val2 !== null ? Math.round(val2) : (cached ? (cached.pct || 0) : 0);
    }
    return {
      active: true, title: title, scope: isOrder ? 'order' : 'products',
      type: type, pct: pct, fixed: fixed, collections: null, productIds: null
    };
  }

  /* Code ist vertrauenswürdig, wenn er im Metaobjekt-Config gepflegt ist
     oder Shopify ihn im Warenkorb als anwendbar meldet (applicable: true). */
  function isKnownOrApplicable(entry) {
    var code = String((entry && entry.code) || '').trim();
    if (!code) return false;
    if ((window.eokCouponConfig || {})[code.toUpperCase()]) return true;
    return entry.applicable === true;
  }

  /* ── Detektion aus /cart.js (einzige Quelle für alle Surfaces) ── */
  function setFromCart(cart) {
    if (!cart) return;
    var next = inactiveCoupon();
    /* Beide Arrays zusammenführen — leeres [] ist truthy, daher concat statt || */
    var apps = [].concat(cart.cart_level_discount_applications || [], cart.discount_applications || []);
    var found = null;
    for (var i = 0; i < apps.length; i++) {
      if (apps[i].type === 'discount_code') { found = apps[i]; break; }
    }
    if (found) {
      next = resolve(found.title, {
        valueType: found.value_type, value: found.value,
        targetSelection: found.target_selection, targetType: found.target_type
      });
      cacheWrite(next);
    } else {
      /* discount_codes liefert den Code-Namen auch bei leerem Warenkorb —
         aber Shopify legt JEDEN String aus /discount/… im Cookie ab, auch
         nicht existierende oder deaktivierte Codes. Ohne Config-Eintrag
         gilt ein Code daher nur, wenn Shopify ihn als applicable bestätigt. */
      var codes = cart.discount_codes || [];
      var valid = null;
      for (var j = 0; j < codes.length; j++) {
        if (isKnownOrApplicable(codes[j])) { valid = codes[j]; break; }
      }
      if (valid) {
        next = resolve(valid.code, { valueType: (valid.type || '').toLowerCase() || null });
      } else {
        cacheClear();
      }
    }
    setCoupon(next);
  }

  function setCoupon(next) {
    var changed = JSON.stringify(next) !== JSON.stringify(_coupon);
    _coupon = next;
    if (changed && _domReady) dispatch();
  }

  function dispatch() {
    var c = _coupon;
    document.dispatchEvent(new CustomEvent('eok:coupon:changed', {
      detail: { coupon: {
        active: c.active,
        targetAll: c.scope === 'order',
        scope: c.scope,
        type: c.type,
        pct: c.pct,
        fixed: c.fixed,
        title: c.title,
        collections: c.collections,
        productIds: c.productIds
      } }
    }));
  }

  /* ── Eligibility: gilt der aktive Coupon für dieses Produkt? ── */
  function applies(info) {
    if (!_coupon.active || _coupon.scope !== 'products') return false;
    if (info && info.noCombo) return false;
    if (!_coupon.collections && !_coupon.productIds) return true;
    if (!info) return false;
    if (_coupon.productIds && info.productId && _coupon.productIds.indexOf(Number(info.productId)) !== -1) return true;
    if (_coupon.collections && info.collections) {
      var list = Array.isArray(info.collections) ? info.collections : String(info.collections).split(',');
      for (var i = 0; i < list.length; i++) {
        var h = String(list[i]).trim();
        if (h && _coupon.collections.indexOf(h) !== -1) return true;
      }
    }
    return false;
  }

  /* ── Rechnung (überall kaufmännisch: Math.round) ─────────────── */
  function salePct(compareAt, price) {
    compareAt = +compareAt || 0; price = +price || 0;
    if (compareAt <= price || compareAt <= 0) return 0;
    return Math.round((compareAt - price) * 100 / compareAt);
  }
  function couponFinal(cents) {
    cents = +cents || 0;
    if (!_coupon.active) return cents;
    if (_coupon.type === 'percentage' && _coupon.pct > 0) return Math.round(cents * (100 - _coupon.pct) / 100);
    if (_coupon.type === 'fixed_amount' && _coupon.fixed > 0) return Math.max(0, cents - _coupon.fixed);
    return cents;
  }
  function couponLabel() {
    if (!_coupon.active) return '';
    if (_coupon.type === 'percentage') return _coupon.pct > 0 ? '-' + _coupon.pct + ' %' : '';
    if (_coupon.fixed > 0) return '-' + money(_coupon.fixed) + ' €';
    return '';
  }
  function money(cents) {
    return (Math.round(+cents || 0) / 100).toFixed(2).replace('.', ',');
  }
  function moneyEur(cents) { return money(cents) + ' €'; }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  /* ── Zentrale Berechnung pro Produkt(variante) ───────────────
     info = { productId, collections (Array|CSV-String), noCombo } */
  function compute(info, price, compareAt) {
    price = +price || 0; compareAt = +compareAt || 0;
    var eligible = applies(info);
    var finalPrice = eligible ? couponFinal(price) : price;
    var lbl = eligible ? couponLabel() : '';
    return {
      price: price,
      compareAt: compareAt,
      isOnSale: compareAt > price,
      salePct: salePct(compareAt, price),
      eligible: eligible,
      couponLabel: lbl,
      couponType: _coupon.type,
      finalPrice: finalPrice,
      hasCouponReduction: eligible && finalPrice < price && lbl !== '',
      title: _coupon.title
    };
  }

  /* ── Renderer: Produktkarten (Startseite/Collections) ───────── */
  /* Preiszeile: max. 2 Preise (Streichpreis + Endpreis) */
  function cardCompareHtml(calc) {
    var strike = 0;
    if (calc.isOnSale) strike = calc.compareAt;
    else if (calc.hasCouponReduction) strike = calc.price;
    if (strike <= 0) return '';
    return '<span class="eok-product-card-price--compare">' + moneyEur(strike) + '</span>';
  }
  function cardPriceHtml(calc, priceVaries) {
    var from = priceVaries ? '<span class="eok-price-from">ab </span>' : '';
    return from + moneyEur(calc.eligible ? calc.finalPrice : calc.price);
  }
  /* Badges nach dem Preis: -X % (Angebot) + 🏷-X % (Coupon) bzw. 🏷 Gratis Versand */
  function cardBadgesHtml(calc) {
    var h = '';
    if (calc.salePct > 0) h += '<div class="eok-rabatt eok-badge-small">-' + calc.salePct + ' %</div>';
    if (calc.eligible) {
      if (calc.couponType === 'free_shipping') {
        h += '<div class="eok-code eok-badge-small">' + TAG + ' Gratis Versand</div>';
      } else {
        h += calc.couponLabel
          ? '<div class="eok-code eok-badge-small">' + TAG + calc.couponLabel + '</div>'
          : '<div class="eok-code eok-badge-small">' + TAG + ' ' + escapeHtml(calc.title) + '</div>';
      }
    }
    return h;
  }
  /* Badges über dem Titel: "Angebot" + 🏷 CODE */
  function cardSalesBadgesHtml(calc) {
    var h = '';
    if (calc.isOnSale) h += '<div class="eok-rabatt eok-badge-small">Angebot</div>';
    if (calc.eligible) h += '<div class="eok-code eok-badge-small">' + TAG + ' ' + escapeHtml(calc.title) + '</div>';
    return h;
  }

  /* ── Renderer: Produktseite (Preisblock + Badges über Titel) ── */
  /* Auch für die PDP-Upsells ("Wird oft dazu gekauft") — identisches Markup. */
  function pdpPriceBlockHtml(calc) {
    var vc = calc.compareAt, vp = calc.price;
    if (calc.isOnSale && calc.hasCouponReduction) {
      return '<div>' +
        '<span class="eok-product-card-price--compare">' + moneyEur(vc) + '</span>' +
        '<span class="eok-rabatt-price ms-1">-' + calc.salePct + ' %</span>' + ARROW +
        '<span class="eok-product-card-price--compare">' + moneyEur(vp) + '</span>' +
        '<span class="eok-code-price ms-1">' + calc.couponLabel + '</span>' + ARROW +
        '<span class="eok-product-card-price">' + moneyEur(calc.finalPrice) + '</span>' +
        '</div>';
    }
    if (calc.isOnSale) {
      return '<span class="eok-product-card-price--compare">' + moneyEur(vc) + '</span>' +
        '<span class="eok-rabatt-price ms-1">-' + calc.salePct + ' %</span>' + ARROW +
        '<span class="eok-product-card-price">' + moneyEur(vp) + '</span>';
    }
    if (calc.hasCouponReduction) {
      return '<span class="eok-product-card-price--compare">' + moneyEur(vp) + '</span>' +
        '<span class="eok-code-price ms-1">' + calc.couponLabel + '</span>' + ARROW +
        '<span class="eok-product-card-price">' + moneyEur(calc.finalPrice) + '</span>';
    }
    return '<span class="eok-product-card-price">' + moneyEur(vp) + '</span>';
  }
  /* Badges über dem Produkttitel: "-X % Angebot" + "🏷 -X % Code CODE" (ohne "+") */
  function pdpBadgesHtml(calc) {
    var h = '';
    if (calc.isOnSale) h += '<div class="eok-rabatt">-' + calc.salePct + ' % Angebot</div>';
    if (calc.eligible) {
      var inner;
      if (calc.couponType === 'free_shipping') {
        inner = TAG + ' Gratis Versand mit Code <strong>' + escapeHtml(calc.title) + '</strong>';
      } else if (calc.hasCouponReduction) {
        inner = TAG + ' ' + calc.couponLabel + ' Code <strong>' + escapeHtml(calc.title) + '</strong>';
      } else {
        inner = TAG + ' Code <strong>' + escapeHtml(calc.title) + '</strong>';
      }
      h += '<div class="eok-code">' + inner + '</div>';
    }
    return h;
  }

  /* ── Renderer: Cart-Drawer ──────────────────────────────────── */
  /* Badges (Line-Items unter dem Titel / Upsells links der Preise):
     -X % (Angebot) + 🏷 -X % (Coupon) */
  function drawerBadgesHtml(salePctVal, showCoupon) {
    var h = '';
    if (salePctVal > 0) h += '<div class="eok-product-specific-discount eok-badge-mr">-' + salePctVal + ' %</div>';
    if (showCoupon) {
      var lbl = _coupon.type === 'free_shipping' ? 'Gratis Versand' : couponLabel();
      h += '<div class="eok-product-specific-coupon eok-badge-mr">' + TAG + ' ' + (lbl || escapeHtml(_coupon.title)) + '</div>';
    }
    return h;
  }
  /* Preise: max. 2 (höchster Streichpreis-Anker + Endpreis) */
  function drawerPriceHtml(strikeCents, finalCents) {
    var h = '';
    if (strikeCents > finalCents) {
      h += '<span class="eok-product-card-price--compare">' + moneyEur(strikeCents) + '</span> ';
    }
    h += '<span class="eok-product-card-price">' + moneyEur(finalCents) + '</span>';
    return h;
  }

  /* ── Alert-Box (Startseite/Collections) ─────────────────────── */
  function alertHtml(title) {
    var suffix = _coupon.type === 'free_shipping'
      ? 'du erhältst kostenlosen Versand'
      : 'du erhältst maximalen Rabatt';
    return TAG + ' <strong>Code ' + escapeHtml(title) + ' ist aktiv</strong> – ' + suffix;
  }
  function updateAlert() {
    updateTopAlert();
    var el = document.getElementById('eok-coupon-alert');
    if (!el) return;
    if (_coupon.active && _coupon.scope === 'products') {
      el.innerHTML = alertHtml(_coupon.title);
      el.style.display = '';
    } else {
      el.style.display = 'none';
    }
  }

  /* ── Code-Banner unter dem Header (theme.liquid, alle Seiten) ── */
  function updateTopAlert() {
    var el = document.getElementById('eok-code-alert-top');
    if (!el) return;
    if (_coupon.active && _coupon.scope === 'products') {
      var html = TAG + ' <strong>' + escapeHtml(_coupon.title) + '</strong> wurde erfolgreich aktiviert.';
      if (el.innerHTML !== html) el.innerHTML = html;
      el.style.display = '';
    } else {
      el.style.display = 'none';
    }
  }

  /* ── Zentrale Hydration: alle Produktkarten der Seite ───────── */
  function updateCard(card) {
    if (card.dataset.available === 'false') return;
    var calc = compute({
      productId: card.dataset.productId,
      collections: card.dataset.collections || '',
      noCombo: card.dataset.noCombo === 'true'
    }, card.dataset.price, card.dataset.compareAt);

    var wrap = card.querySelector('.eok-card-price-wrap');
    if (wrap) {
      var compEl = wrap.querySelector('.eok-compare');
      if (compEl) {
        var compHtml = cardCompareHtml(calc);
        compEl.innerHTML = compHtml;
        compEl.style.display = compHtml ? '' : 'none';
      }
      var priceEl = wrap.querySelector('.eok-product-card-price');
      if (priceEl) priceEl.innerHTML = cardPriceHtml(calc, card.dataset.priceVaries === 'true');
      var badgesEl = wrap.querySelector('.eok-card-badges');
      if (badgesEl) badgesEl.innerHTML = cardBadgesHtml(calc);
    }
    var salesEl = card.querySelector('.eok-sales-badges');
    if (salesEl) {
      var salesHtml = cardSalesBadgesHtml(calc);
      salesEl.innerHTML = salesHtml;
      salesEl.style.display = salesHtml ? '' : 'none';
    }
  }
  function updateAllCards() {
    document.querySelectorAll('.eok-product-card[data-product-id]').forEach(updateCard);
  }

  /* ── Zentrale Hydration: PDP-Upsells ("Wird oft dazu gekauft") ── */
  function updateUpsellPrices() {
    document.querySelectorAll('.eok-upsell-price[data-price]').forEach(function (el) {
      var calc = compute({
        productId: el.dataset.productId,
        collections: el.dataset.collections || '',
        noCombo: el.dataset.noCombo === 'true'
      }, el.dataset.price, el.dataset.compareAt);
      el.innerHTML = pdpPriceBlockHtml(calc);
    });
  }

  /* ── Event-Verkabelung ──────────────────────────────────────── */
  document.addEventListener('eok:coupon:changed', function () {
    updateAllCards();
    updateUpsellPrices();
    updateAlert();
  });

  function initFromSeed() {
    var seed = window.eokCouponSeed;
    if (seed && seed.title) {
      _coupon = resolve(seed.title, {
        valueType: seed.valueType, value: seed.value,
        targetSelection: seed.targetSelection, targetType: seed.targetType
      });
      cacheWrite(_coupon);
    }
    dispatch(); /* Baseline-Hydration für alle Surfaces (auch im inaktiven Fall) */
  }

  function init() {
    _domReady = true;
    initFromSeed();
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (window.eokUpdateCartBadges) window.eokUpdateCartBadges(cart.item_count);
        setFromCart(cart);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── Öffentliche API ────────────────────────────────────────── */
  window.EokPricing = {
    getCoupon: function () { return JSON.parse(JSON.stringify(_coupon)); },
    setFromCart: setFromCart,
    resolve: resolve,
    applies: applies,
    compute: compute,
    salePct: salePct,
    couponFinal: couponFinal,
    couponLabel: couponLabel,
    money: money,
    moneyEur: moneyEur,
    escapeHtml: escapeHtml,
    cardCompareHtml: cardCompareHtml,
    cardPriceHtml: cardPriceHtml,
    cardBadgesHtml: cardBadgesHtml,
    cardSalesBadgesHtml: cardSalesBadgesHtml,
    pdpPriceBlockHtml: pdpPriceBlockHtml,
    pdpBadgesHtml: pdpBadgesHtml,
    drawerBadgesHtml: drawerBadgesHtml,
    drawerPriceHtml: drawerPriceHtml,
    alertHtml: alertHtml,
    updateAllCards: updateAllCards,
    updateUpsellPrices: updateUpsellPrices,
    updateAlert: updateAlert
  };
})();
